import React, { useState, useEffect } from 'react';

const GOLD='#F5A623', DARK='#2C2C2A', NAVY='#1E3A5F', GREEN='#22C55E', RED='#EF4444';

const PUBLIC_DOC_LABELS = {
  talon: 'Talon / Certificat înmatriculare',
  polita_rca: 'Poliță RCA',
  polita_casco: 'Poliță CASCO',
  dovada_itp: 'Dovadă ITP',
  dovada_rovinieta: 'Dovadă Rovinieta',
  civ: 'CIV — Carte identitate vehicul',
};

function statusColor(days) {
  if (days === null) return '#D3D1C7';
  if (days < 0 || days <= 7) return RED;
  if (days <= 30) return GOLD;
  return GREEN;
}

function statusBg(days) {
  if (days === null) return '#F4F4F4';
  if (days < 0 || days <= 7) return '#FEE2E2';
  if (days <= 30) return '#FEF3DC';
  return '#DCFCE7';
}

function statusLabel(days) {
  if (days === null) return 'Nedefinit';
  if (days < 0) return 'Expirat';
  if (days === 0) return 'Expira azi';
  return days + ' zile';
}

function DocPreviewModal({ doc, onClose }) {
  if (!doc) return null;
  const ext = (doc.original_filename || '').split('.').pop().toLowerCase();
  const isPdf = ext === 'pdf' || (doc.mime_type && doc.mime_type.includes('pdf'));
  const isImage = ['jpg','jpeg','png','webp','heic','gif'].includes(ext) || (doc.mime_type && doc.mime_type.startsWith('image/'));
  const fileUrl = doc.s3_key;

  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,.75)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'}}>
      <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:'14px',width:'100%',maxWidth:'760px',maxHeight:'90vh',display:'flex',flexDirection:'column',overflow:'hidden'}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 18px',borderBottom:'0.5px solid #D3D1C7',flexShrink:0}}>
          <div>
            <div style={{fontWeight:800,fontSize:'14px',color:DARK}}>{PUBLIC_DOC_LABELS[doc.doc_type] || doc.doc_type}</div>
            <div style={{fontSize:'11px',color:'#888',marginTop:'2px'}}>{doc.original_filename}</div>
          </div>
          <button onClick={onClose} style={{background:'#F4F4F4',border:'none',borderRadius:'8px',padding:'6px 12px',cursor:'pointer',fontSize:'16px',color:DARK}}>✕</button>
        </div>
        <div style={{flex:1,overflow:'auto',display:'flex',alignItems:'center',justifyContent:'center',padding:'16px',background:'#F4F4F4',minHeight:'300px'}}>
          {isPdf ? (
            <iframe src={fileUrl} title="Document PDF" style={{width:'100%',height:'60vh',border:'none',borderRadius:'8px',background:'#fff'}}/>
          ) : isImage ? (
            <img src={fileUrl} alt={doc.original_filename} style={{maxWidth:'100%',maxHeight:'65vh',borderRadius:'8px',objectFit:'contain',boxShadow:'0 2px 12px rgba(0,0,0,.12)'}}/>
          ) : (
            <div style={{textAlign:'center',color:'#888'}}>
              <div style={{fontSize:'48px',marginBottom:'12px'}}>📄</div>
              <div style={{fontSize:'14px',fontWeight:600}}>Previzualizare indisponibilă</div>
              <a href={fileUrl} target="_blank" rel="noreferrer" style={{color:NAVY,fontSize:'12px',marginTop:'8px',display:'inline-block'}}>Descarcă fișierul →</a>
            </div>
          )}
        </div>
        <div style={{padding:'12px 18px',borderTop:'0.5px solid #D3D1C7',display:'flex',justifyContent:'flex-end',flexShrink:0}}>
          <a href={fileUrl} target="_blank" rel="noreferrer" style={{background:NAVY,color:'#fff',padding:'8px 18px',borderRadius:'9px',fontSize:'12px',fontWeight:700,textDecoration:'none'}}>
            ⬇ Descarcă
          </a>
        </div>
      </div>
    </div>
  );
}

export default function VehiclePublicPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [previewDoc, setPreviewDoc] = useState(null);

  useEffect(() => {
    const path = window.location.pathname;
    const token = path.split('/masina/')[1];
    if (!token) { setError('Token invalid.'); setLoading(false); return; }
    fetch('/api/public/vehicle/' + token)
      .then(r => r.json())
      .then(d => {
        if (d.error) setError(d.error);
        else setData(d);
        setLoading(false);
      })
      .catch(() => { setError('Eroare conexiune server.'); setLoading(false); });
  }, []);

  const s = {
    wrap: { minHeight: '100vh', background: '#F4F4F4', fontFamily: "'Syne', sans-serif" },
    topbar: { background: DARK, height: '58px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px' },
    brandIcon: { background: GOLD, width: '34px', height: '34px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: '13px', color: DARK },
    content: { maxWidth: '680px', margin: '0 auto', padding: '24px 16px' },
    card: { background: '#fff', border: '0.5px solid #D3D1C7', borderRadius: '14px', padding: '18px 22px', marginBottom: '12px' },
  };

  const Topbar = () => (
    <div style={s.topbar}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={s.brandIcon}>EA</div>
        <div style={{ color: '#fff', fontSize: '15px', fontWeight: 800 }}>
          dosarmasina.ro <span style={{ color: 'rgba(255,255,255,.4)', fontSize: '10px', fontWeight: 400 }}>· by Premium Support Iasi</span>
        </div>
      </div>
      <div style={{ background: 'rgba(255,255,255,.1)', borderRadius: '8px', padding: '5px 12px', color: 'rgba(255,255,255,.6)', fontSize: '11px' }}>
        Acces public
      </div>
    </div>
  );

  if (loading) return (
    <div style={s.wrap}>
      <Topbar/>
      <div style={{ ...s.content, textAlign: 'center', paddingTop: '80px' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚗</div>
        <div style={{ fontWeight: 700, fontSize: '16px' }}>Se incarca...</div>
      </div>
    </div>
  );

  if (error) return (
    <div style={s.wrap}>
      <Topbar/>
      <div style={{ ...s.content, textAlign: 'center', paddingTop: '80px' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
        <div style={{ fontWeight: 800, fontSize: '18px', marginBottom: '8px' }}>Masina nu a fost gasita</div>
        <div style={{ fontSize: '13px', color: '#888' }}>{error}</div>
      </div>
    </div>
  );

  const { vehicle, expiry, documents } = data;
  const expiryItems = [
    { key: 'rca', label: 'RCA', icon: '🛡️' },
    { key: 'casco', label: 'CASCO', icon: '🚗' },
    { key: 'itp', label: 'ITP', icon: '🔍' },
    { key: 'rovinieta', label: 'Rovinieta', icon: '🛣️' },
  ];

  return (
    <div style={s.wrap}>
      <Topbar/>
      {previewDoc && <DocPreviewModal doc={previewDoc} onClose={() => setPreviewDoc(null)}/>}

      <div style={s.content}>
        {/* Hero vehicul */}
        <div style={{ background: NAVY, borderRadius: '14px', padding: '22px 24px', marginBottom: '14px' }}>
          <div style={{ fontFamily: 'monospace', fontSize: '22px', fontWeight: 700, color: GOLD, border: '2px solid ' + GOLD, display: 'inline-block', padding: '4px 14px', borderRadius: '7px', marginBottom: '10px', letterSpacing: '2px' }}>
            {vehicle.plate_number || '—'}
          </div>
          <div style={{ color: '#fff', fontSize: '20px', fontWeight: 800, marginBottom: '4px' }}>
            {[vehicle.brand, vehicle.model, vehicle.year].filter(Boolean).join(' ') || 'Vehicul'}
          </div>
          <div style={{ color: 'rgba(255,255,255,.5)', fontSize: '12px' }}>
            {[vehicle.fuel_type, vehicle.emission_norm].filter(Boolean).join(' · ')}
          </div>
        </div>

        {/* Carduri expirari */}
        <div style={{ ...s.card }}>
          <div style={{ fontSize: '13px', fontWeight: 800, marginBottom: '14px', color: DARK }}>
            ⏰ Status documente
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
            {expiryItems.map(item => {
              const info = expiry[item.key];
              const days = info ? info.days_left : null;
              const color = statusColor(days);
              const bg = statusBg(days);
              const label = statusLabel(days);
              return (
                <div key={item.key} style={{ background: '#fff', border: '0.5px solid #D3D1C7', borderRadius: '12px', padding: '14px', borderTop: '3px solid ' + color }}>
                  <div style={{ fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', marginBottom: '6px' }}>
                    {item.icon} {item.label}
                  </div>
                  {info && info.date ? (
                    <>
                      <div style={{ fontFamily: 'monospace', fontSize: '14px', fontWeight: 700, marginBottom: '6px' }}>
                        {new Date(info.date).toLocaleDateString('ro-RO')}
                      </div>
                      <span style={{ background: bg, color, fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '7px' }}>
                        {days < 0 ? '✗ ' : days <= 30 ? '⚠ ' : '✓ '}{label}
                      </span>
                    </>
                  ) : (
                    <div style={{ fontSize: '12px', color: '#aaa' }}>Nedefinit</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Expirari personalizate */}
        {data.custom_expiries && data.custom_expiries.length > 0 && (
          <div style={s.card}>
            <div style={{ fontSize: '13px', fontWeight: 800, marginBottom: '14px', color: DARK }}>
              Documente personalizate
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
              {data.custom_expiries.map(c => {
                const days = c.days_left;
                const color = statusColor(days);
                const bg = statusBg(days);
                const label = statusLabel(days);
                return (
                  <div key={c.id} style={{ background: '#fff', border: '0.5px solid #D3D1C7', borderRadius: '12px', padding: '14px', borderTop: '3px solid ' + color }}>
                    <div style={{ fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', marginBottom: '6px' }}>
                      {c.label}
                    </div>
                    {c.expiry_date ? (
                      <>
                        <div style={{ fontFamily: 'monospace', fontSize: '14px', fontWeight: 700, marginBottom: '6px' }}>
                          {new Date(c.expiry_date).toLocaleDateString('ro-RO')}
                        </div>
                        <span style={{ background: bg, color, fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '7px' }}>
                          {days < 0 ? 'Expirat' : days === 0 ? 'Expira azi' : label}
                        </span>
                      </>
                    ) : (
                      <div style={{ fontSize: '12px', color: '#aaa' }}>Data nedefinita</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Documente publice */}
        {documents && documents.length > 0 && (
          <div style={s.card}>
            <div style={{ fontSize: '13px', fontWeight: 800, marginBottom: '14px', color: DARK }}>
              📎 Documente ({documents.length})
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {documents.map(doc => {
                const ext = (doc.original_filename || '').split('.').pop().toLowerCase();
                const isPdf = ext === 'pdf' || (doc.mime_type && doc.mime_type.includes('pdf'));
                return (
                  <div key={doc.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', background: '#F4F4F4', borderRadius: '9px' }}>
                    <span style={{ fontSize: '20px', flexShrink: 0 }}>{isPdf ? '📄' : '🖼️'}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '13px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {PUBLIC_DOC_LABELS[doc.doc_type] || doc.doc_type}
                      </div>
                      <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>
                        {doc.original_filename} · {new Date(doc.uploaded_at).toLocaleDateString('ro-RO')}
                      </div>
                    </div>
                    <button onClick={() => setPreviewDoc(doc)}
                      style={{ background: NAVY, color: '#fff', border: 'none', borderRadius: '8px', padding: '6px 14px', fontSize: '12px', fontWeight: 700, cursor: 'pointer', flexShrink: 0, fontFamily: "'Syne',sans-serif" }}>
                      👁 Vezi
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Footer branding */}
        <div style={{ textAlign: 'center', padding: '24px 0 8px', color: '#888', fontSize: '12px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: DARK, color: '#fff', borderRadius: '10px', padding: '8px 16px', marginBottom: '8px' }}>
            <div style={{ background: GOLD, width: '22px', height: '22px', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: '9px', color: DARK }}>EA</div>
            <span style={{ fontWeight: 700, fontSize: '13px' }}>dosarmasina.ro</span>
          </div>
          <div>Platforma de management auto · by Premium Support Iasi</div>
        </div>
      </div>
    </div>
  );
}
